/**
 * Activity React Query Hooks
 * Reads the audit feed powering the dashboard's Recent Activity card.
 */

import { useQuery } from '@tanstack/react-query';
import { getActivity, type GetActivityParams } from '@/lib/api/activity';

export const activityKeys = {
  all: ['activity'] as const,
  list: (params: GetActivityParams) => [...activityKeys.all, 'list', params] as const,
};

/**
 * Fetch activity newest-first. Defaults suit the dashboard feed; pass filters to
 * scope to a single entity/actor.
 */
export function useActivity(params: GetActivityParams = {}) {
  return useQuery({
    queryKey: activityKeys.list(params),
    queryFn: () => getActivity(params),
    staleTime: 60 * 1000, // 1 minute — the feed is informational, not live.
  });
}
